export default {
  name: 'marking--treeMrkForBroker',
  urlParamName: 'marking--treeMrkForBroker',
};